import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { MainRolesComponent } from './main-roles/main-roles.component';
import { AgregarRolComponent } from './agregar-rol/agregar-rol.component';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { ListaRolesComponent } from './lista-roles/lista-roles.component';
import { PrimeNgModule } from 'src/app/PrimeNg.module';



@NgModule({
  declarations: [
    MainRolesComponent,
    AgregarRolComponent,
    ListaRolesComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    PrimeNgModule
  ],
  exports:[
    MainRolesComponent,
    AgregarRolComponent,
    ListaRolesComponent
  ]
})
export class RolesModule { }
